import { FC, lazy, useState, useEffect } from "react";
import { MantineProvider } from "@mantine/core";
import { theme } from "./theme";
import {
  AnimatePresenceProvider,
  AuthProvider,
  GeolocationProvider,
  ReferralSystemProvider,
  RouterProvider,
  SentryProvider,
  StoreProvider,
  StreakProvider,
} from "@shared/providers";

const TonConnectProvider = lazy(() =>
  import("@shared/providers").then((module) => ({
    default: module.TonConnectProvider,
  }))
);

import "react-swipeable-list/dist/styles.css";
import "@mantine/core/styles.css";
import "./styles/global.scss";
import "./styles/theme.scss";
import { Loader } from "@widgets/Loader";

export const App: FC = () => {
  const [isProvidersMounted, setIsProvidersMounted] = useState(false);

  useEffect(() => {
    setIsProvidersMounted(true);
  }, []);

  if (!isProvidersMounted) {
    return <Loader />;
  }

  return (
    <SentryProvider>
      <StoreProvider>
        <AuthProvider>
          {/* <Suspense fallback={<Loader />}> */}
          <TonConnectProvider>
            <GeolocationProvider>
              <ReferralSystemProvider>
                <StreakProvider>
                  <MantineProvider theme={theme} defaultColorScheme="dark">
                    <AnimatePresenceProvider>
                      <RouterProvider />
                    </AnimatePresenceProvider>
                  </MantineProvider>
                </StreakProvider>
              </ReferralSystemProvider>
            </GeolocationProvider>
          </TonConnectProvider>
          {/* </Suspense> */}
        </AuthProvider>
      </StoreProvider>
    </SentryProvider>
  );
};
